import exercise1 from './i18n/exercise1';
import exercise2 from './i18n/exercise2';
import exercise3 from './i18n/exercise3';
import exercise4 from './i18n/exercise4';
import exercise5 from './i18n/exercise5';
import exercise6 from './i18n/exercise6';

class IdentifyingLogicaOrderController {

  constructor(helperService, $sce) {
    "ngInject";
    Object.assign(this, { helperService, $sce });
    this.videoUrl = this.$sce.trustAsResourceUrl('https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1');

    this.lang = 'en';

    this.exercise1 = exercise1[this.lang];
    this.exercise2 = exercise2[this.lang];
    this.exercise3 = exercise3[this.lang];
    this.exercise4 = exercise4[this.lang];
    this.exercise5 = exercise5[this.lang];
    this.exercise6 = exercise6[this.lang];

  }

}

export default IdentifyingLogicaOrderController;



// WEBPACK FOOTER //
// ./client/app/modules/courses/6/identifyingLogicaOrder/identifyingLogicaOrder.controller.js